import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: "https://1c1ac1f79b4034f1af92a9039c74f135@o4509867853807616.ingest.us.sentry.io/4509867854987264",
  sendDefaultPii: true
});

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary>
    <App />
  </Sentry.ErrorBoundary>
)
